//@flow

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

import { WhitePanel } from '../../../../components';
import { getTrekPreference } from '../../../../redux/actions/trekPreferenceActions';
import { useEffectOnFirstRender } from '../../../../hooks';

type Service = {
  name: string,
  key: null | string,
  order: number,
  poster_type: null | string,
  is_locked: boolean,
  is_available: boolean,
};

type Props = {
  preferences: Array<Service> | null,
  fetchTrekPreferences: () => void,
};

const mapActionToProps = ({ selectedTrek: { preferences } }) => ({
  preferences,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchTrekPreferences: () => dispatch(getTrekPreference({ trekId: ownProps.trekId })),
});

function TrekPreferencesList(props: Props) {
  useEffectOnFirstRender(fetchPrefs);

  async function fetchPrefs() {
    try {
      await props.fetchTrekPreferences();
    } catch (err) {
      console.log(err);
    }
  }

  const { preferences } = props;

  if (isEmpty(preferences)) return null;

  const included = preferences.filter(p => p.is_available);
  const excluded = preferences.filter(p => !p.is_available);

  return (
    <WhitePanel>
      <Row className="no-gutters">
        <Services services={included} className="include" title="INCLUDED" />
        <Services services={excluded} className="exclude" title="EXCLUDED" />
      </Row>
    </WhitePanel>
  );
}

type ServicesProps = {
  className: string,
  title: string,
  services: Array<Service> | null,
};

const Services = ({ className, title, services }: ServicesProps) => (
  <Col md="6" className={className}>
    <h2>{title}</h2>
    <ul className="include-exclude">
      {!isEmpty(services) &&
        services.map(({ name }: { name: string }) => <li key={name}>{name}</li>)}
    </ul>
  </Col>
);

export default connect(
  mapActionToProps,
  mapDispatchToProps
)(TrekPreferencesList);



// WEBPACK FOOTER //
// ./src/screens/Trek/Guided/Review/Preferences.js